<template>
  <v-container>
    <v-card tile class="elevation-1">
      <v-tabs
        v-model="tab"
        height="35px"
        grow
        show-arrows
        :background-color="tabsBackground"
      >
        <v-tab v-for="item in items" :key="item.tab">{{ item.tab }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item.tab">
          <component v-bind:is="item.content"></component>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import i18n from "../i18n";
import MainForm from "../components/Configuration/MainForm.vue";
import DicomForm from "../components/Configuration/DicomForm.vue";
import StorageForm from "../components/Configuration/StorageForm.vue";
import WorklistForm from "../components/Configuration/WorklistForm.vue";
import PrintServerForm from "../components/Configuration/PrintServerForm.vue";
import DicomWebForm from "../components/Configuration/DicomWebForm.vue";
import MetricsForm from "../components/Configuration/MetricsForm.vue";

export default {
  name: "Configuration",
  components: {
    MainForm,
    DicomForm,
    StorageForm,
    WorklistForm,
    DicomWebForm,
    PrintServerForm,
    MetricsForm,
  },
  computed: {
    tabsBackground() {
      if (this.$vuetify.theme.dark) {
        return "grey darken-2";
      } else {
        return "grey lighten-4";
      }
    },
  },
  mounted() {
    // Configuration
    let config = [
      {
        config: "main",
        tab: i18n.t("Main"),
        content: "MainForm",
      },
      {
        config: "dicom",
        tab: i18n.t("Dicom"),
        content: "DicomForm",
      },
      {
        config: "storage",
        tab: i18n.t("Storage"),
        content: "StorageForm",
      },
      {
        config: "worklist",
        tab: i18n.t("Worklist"),
        content: "WorklistForm",
      },
      {
        config: "dicomWeb",
        tab: i18n.t("DicomWeb"),
        content: "DicomWebForm",
      },
      {
        config: "printServer",
        tab: i18n.t("PrintServer"),
        content: "PrintServerForm",
      },
      {
        config: "metrics",
        tab: i18n.t("Metrics"),
        content: "MetricsForm",
      },
    ];

    let configuration = this.$store.getters.resources.configuration;
    for (let i = 0; i < config.length; i++) {
      if (configuration[config[i].config].read) {
        this.items.push({
          tab: config[i].tab,
          content: config[i].content,
        });
      }
    }
  },
  data: () => ({
    tab: null,
    items: [],
  }),
  methods: {
    checkNested(obj, level, ...rest) {
      if (obj === undefined) return false;
      if (rest.length == 0 && {}.hasOwnProperty.call(obj, level)) return true;
      return this.checkNested(obj[level], ...rest);
    },
  },
};
</script>

<style scoped>
</style>